import dayjs from 'dayjs';
import tz from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(tz)
dayjs.extend(utc)

const timeZone = dayjs.tz.guess();
console.log('current timezone', timeZone)

export function getLocalMoment(dtString, formatString){
    if(formatString){
        return dayjs.utc(dtString).local().format(formatString)
    }
    
    if(dtString){
        return dayjs.utc(dtString).local()
    }

    return dayjs.utc().local()
}